import {AlpineComponent} from 'alpinejs';
import PhotoSwipeLightbox from 'photoswipe/lightbox';

type ImageData = {}

export default (): AlpineComponent<ImageData> => ({
  init() {
    const lightbox = new PhotoSwipeLightbox({
      gallery: this.$refs.ceImage,
      children: 'a',
      zoom: false,
      pswpModule: () => import('photoswipe')
    });
    lightbox.init();
  }
});
